// EditBlog.tsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../../api/api";
import EditBlogForm from "./EditBlogForm";

interface BlogData {
  id:string;
  title: string;
  authorName:string;
  description: string;
  readTime: number;
  content: string;
  category: string;
  tags: string[];
  isFeatured: boolean;
  isPublished: boolean;
  image?: string;
}

const EditBlog: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [blogData, setBlogData] = useState<BlogData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        setLoading(true);
        const response = await API.get(`/blogs/${id}`);
        setBlogData(response.data.blog);
        console.log("Fetched Blog:", response.data.blog);
      } catch (error) {
        console.error("Error fetching blog:", error);
        setError("Failed to load blog data");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchBlog();
  }, [id]);

  return (
    <div>
      {loading ? (
        <p>Loading blog data...</p>
      ) : error ? (
        <p>{error}</p>
      ) : blogData ? (
        <EditBlogForm initialData={blogData} />
      ) : (
        <p>No blog data found</p>
      )}
    </div>
  );
};

export default EditBlog;